import classNames from 'clsx';
import React from 'react';

import type { LinkedImage } from '@swf/cms';
import { CMSImage, CMSLink } from '@swf/cms';
import type { ClassNameProp } from '@swf/core/types/Props';

import styles from './CMSLinkedImage.scss';

const CMSLinkedImage: React.FC<LinkedImage & Partial<ClassNameProp>> = ({
  link,
  image,
  animated,
  className = ''
}) => (
  <CMSLink {...link} className={className}>
    <CMSImage {...image} className={classNames(className, { [styles.animateOnHover]: animated })} />
  </CMSLink>
);

export default CMSLinkedImage;
